import React from 'react';
import { Typography } from '@saucelabs/ds-typography';
import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';

import constants from '../../../constants';

const {
  DAYS_BEFORE_SHOWING_DELETION_LABEL_THRESHOLD,
} = constants;

type TableCellUploadedProps = {
  group: appStorageRecords.AppStorageGroup
};

const TableCellUploaded: React.FC<TableCellUploadedProps> = ({ group }) => (
  <>
    <Typography
      data-qa="app-management-groups-table-cell-uploaded-label"
    >
      {group.recent.getCreationDateShortLabel()}
    </Typography>
    {group.recent.getDaysUntilDeletion() < DAYS_BEFORE_SHOWING_DELETION_LABEL_THRESHOLD && (
      <Typography
        className="text-red-900"
        data-qa="app-management-groups-table-cell-uploaded-deletion-notice"
        variant="body-small"
      >
        {group.recent.getDeletionDatePrettyLabel()}
      </Typography>
    )}
  </>
);

export default TableCellUploaded;
